export default "__VITE_ASSET__8d34a3fd__"